<template>
  <NavigationHeader :title="wp.title" />
</template>

<script>
export default {
  name: 'NewsHeader',
  inject: ['wp']
}
</script>
